import { ReactNode } from "react";

export type ClockLogoProps = {
  children?: ReactNode;
};

export type ScrewPosition = {
  x: string;
  y: string;
  angle: number;
};

export const positions: ScrewPosition[] = [
  { x: '4.7%', y: '3.5%', angle: 190 },     // top-left
  { x: '95.2%', y: '3.5%', angle: 160 },  // top-right
  { x: '95%', y: '96.5%', angle: 150 }, // bottom-right
  { x: '5%', y: '96.5%', angle: 170 }, // bottom-left
];
